import { useEffect, useSyncExternalStore } from 'react'
import {
  getPredictionEntrySnapshot,
  refreshPredictionEntry,
  startPredictionEntrySync,
  subscribePredictionEntry,
} from './predictionEntryStore'

/**
 * แสดง entry point ทายผล (dashboard CTA, float, แท็บ) เมื่อ
 * tenant เปิด prediction + master switch เปิด + มีงาน open
 */
export function usePredictionUserEntry(predictionEnabled?: boolean) {
  const snapshot = useSyncExternalStore(
    subscribePredictionEntry,
    getPredictionEntrySnapshot,
    getPredictionEntrySnapshot,
  )

  useEffect(() => startPredictionEntrySync(predictionEnabled), [predictionEnabled])

  return {
    showPredictionEntry:
      predictionEnabled === true && snapshot.userEntryVisible,
    hasOpenEvents: snapshot.hasOpenEvents,
    userEntryVisible: snapshot.userEntryVisible,
    checked: snapshot.checked,
    refresh: () => refreshPredictionEntry(true),
  }
}
